import React from 'react'
import { node, bool } from 'prop-types'
import { css } from '@emotion/react'
import mediaQueries from '../../layout/media-queries'

const cardWrapperCss = (isImage) => css`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 32px;

  ${mediaQueries.xsmallScreen(200)} {
    margin-bottom: 60px;
  }

  ${mediaQueries.largeScreen()} {
    ${isImage && 'min-height: 440px'};
  }
`

const cardImageCss = (isImage) => css`
  width: calc(100% + 2px);
  object-fit: contain;
  position: relative;

  > div {
    ${isImage &&
    css`
      padding-top: ${(9 / 16) * 100}%;
    `};

    > img,
    > svg,
    > .gatsby-image-wrapper {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: -1px;
    }
  }
`

const cardInfoCss = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 16px 24px 16px;
  flex: 1 0 auto;
  align-items: flex-start;

  ${mediaQueries.xsmallScreen(200)} {
    padding: 16px 32px 24px 16px;
  }

  ${mediaQueries.smallScreen()} {
    padding: 32px 32px 48px 32px;
  }

  ${mediaQueries.largeScreen()} {
    padding: 32px 36px 48px 36px;
  }

  ${mediaQueries.xlargeScreen()} {
    padding: 32px 50px 48px 50px;
  }
`

const imgCss = (withMargin) => css`
  max-height: 40px;
  ${withMargin && 'margin-bottom: 16px;'}

  img {
    max-height: 40px;
    max-width: 100%;
  }
`

const Card = ({ image, description, actions, logo, withMargin, ...rest }) => (
  <article css={cardWrapperCss(image)} {...rest}>
    <div css={cardImageCss(image)}>
      <div>{image}</div>
    </div>
    <div css={cardInfoCss}>
      {logo && <div css={imgCss(withMargin)}>{logo}</div>}
      {description}
      {actions}
    </div>
  </article>
)

Card.propTypes = {
  image: node,
  description: node,
  actions: node,
  logo: node,
  withMargin: bool,
}

export default Card
